// import React from 'react';
// import './real_time.css';
// import leftImage from "../../../img/des_sec/Real-Time Background Checks.svg"
// import card1 from "../../../img/des_sec/real_time_card_1.svg"
// import card2 from "../../../img/des_sec/real_time_card_2.svg"
// import card3 from "../../../img/des_sec/real_time_card_3.svg"
// import { useRef } from 'react';

// const RealTime = () => {
//   const sliderRef = useRef(null);
  
//     const scrollLeft = () => {
//       if (sliderRef.current) {
//         sliderRef.current.scrollBy({ left: -200, behavior: 'smooth' });
//       }
//     };
  
//     const scrollRight = () => {
//       if (sliderRef.current) {
//         sliderRef.current.scrollBy({ left: 200, behavior: 'smooth' });
//       }
//     };
  
//     return (
//       <div className="onboarding-container-rt">
        
//         <div className="background-image-rt"></div>
        
        
//         <div className="content-wrapper-rt">
//           {/* Mobile title comes first */}
//           <h1 className="title-rt mobile-title">Real-Time Background Checks</h1>
          
//           {/* Left illustration */}
//           <div className="left-illustration-rt">
//             <img src={leftImage} alt="Onboarding Illustration" />
//           </div>
          
//           {/* Right content */}
//           <div className="right-content-rt">
//             {/* Desktop title (hidden on mobile) */}
//             <h1 className="title-rt desktop-title">Real-Time Background Checks</h1>
            
//             {/* Cards slider container */}
//             <div className="cards-slider-container">
//               <button className="slider-arrow left-arrow" onClick={scrollLeft}>&lt;</button>
              
//               {/* Cards stack with slider functionality */}
//               <div className="cards-stack-rt" ref={sliderRef}>
//                 <img src={card1} alt="Instant Aadhaar Verification" className="feature-card-rt" />
//                 <img src={card2} alt="Customizable Approval Workflows" className="feature-card-rt" />
//                 <img src={card3} alt="Integrated Agency Management" className="feature-card-rt" />
//               </div>
              
//               <button className="slider-arrow right-arrow" onClick={scrollRight}>&gt;</button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
// };

// export default RealTime;

import React, { useRef, useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import './real_time.css';
import leftImage from "../../../img/des_sec/Real-Time Background Checks.svg"
import card1 from "../../../img/des_sec/real_time_card_1.svg"
import card2 from "../../../img/des_sec/real_time_card_2.svg"
import card3 from "../../../img/des_sec/real_time_card_3.svg"

const RealTime = () => {
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '-50px 0px'
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  // Animation for mobile title
  const mobileTitleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: { 
      tension: 180, 
      friction: 35,
      mass: 1
    },
    delay: inView ? 100 : 0
  });

  // Animation for left illustration
  const leftIllustrationAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-30px) scale(0.95)',
    config: { 
      tension: 160, 
      friction: 30,
      mass: 1.2
    },
    delay: inView ? 200 : 0
  });

  // Animation for desktop title
  const desktopTitleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: { 
      tension: 180, 
      friction: 35,
      mass: 1
    },
    delay: inView ? 300 : 0
  });

  // Animation for left arrow
  const leftArrowAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-10px) scale(0.9)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 400 : 0
  });

  // Animation for right arrow
  const rightArrowAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(10px) scale(0.9)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 400 : 0
  });

  // Individual card animations with staggered delays
  const card1Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { 
      tension: 140, 
      friction: 25,
      mass: 0.9
    },
    delay: inView ? 550 : 0
  });

  const card2Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { 
      tension: 140, 
      friction: 25,
      mass: 0.9
    },
    delay: inView ? 700 : 0
  });

  const card3Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { 
      tension: 140, 
      friction: 25,
      mass: 0.9
    },
    delay: inView ? 850 : 0
  });

  return (
    <div className="onboarding-container-rt" ref={containerRef}>
      
      <div className="background-image-rt"></div>
      
      <div className="content-wrapper-rt">
        {/* Mobile title comes first */}
        <animated.h1 
          className="title-rt mobile-title"
          style={{
            ...mobileTitleAnimation,
            position: 'relative',
            zIndex: 1
          }}
        >
          Real-Time Background Checks
        </animated.h1>
        
        {/* Left illustration */}
        <animated.div 
          className="left-illustration-rt"
          style={{
            ...leftIllustrationAnimation,
            position: 'relative',
            zIndex: 1
          }}
        >
          <img src={leftImage} alt="Real-Time Background Checks Illustration" />
        </animated.div>
        
        {/* Right content */}
        <div className="right-content-rt">
          {/* Desktop title (hidden on mobile) */}
          <animated.h1 
            className="title-rt desktop-title"
            style={{
              ...desktopTitleAnimation,
              position: 'relative',
              zIndex: 1
            }}
          >
            Real-Time Background Checks
          </animated.h1>
          
          {/* Cards slider container */}
          <div className="cards-slider-container">
            <animated.button 
              className="slider-arrow left-arrow" 
              onClick={scrollLeft}
              style={{
                ...leftArrowAnimation,
                position: 'relative',
                zIndex: 1
              }}
            >
              &lt;
            </animated.button>
            
            {/* Cards stack with slider functionality */}
            <div className="cards-stack-rt" ref={sliderRef}>
              <animated.img 
                src={card1} 
                alt="Real-Time Feature 1" 
                className="feature-card-rt"
                style={{
                  ...card1Animation,
                  position: 'relative',
                  zIndex: 1
                }}
              />
              <animated.img 
                src={card2} 
                alt="Real-Time Feature 2" 
                className="feature-card-rt"
                style={{
                  ...card2Animation,
                  position: 'relative',
                  zIndex: 1
                }}
              />
              <animated.img 
                src={card3} 
                alt="Real-Time Feature 3" 
                className="feature-card-rt"
                style={{
                  ...card3Animation,
                  position: 'relative',
                  zIndex: 1
                }}
              />
            </div>
            
            <animated.button 
              className="slider-arrow right-arrow" 
              onClick={scrollRight}
              style={{
                ...rightArrowAnimation,
                position: 'relative',
                zIndex: 1
              }}
            >
              &gt;
            </animated.button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealTime;